import { Icon } from '@platform/components';

export const UserEmailCell = ({
  email,
  emailVerified,
  userId,
  setEmailVerifyUserId,
}: {
  email: string;
  emailVerified: boolean;
  userId: number;
  setEmailVerifyUserId: React.Dispatch<React.SetStateAction<number | undefined>>;
}) => {
  return (
    <div className='flex gap-2 justify-between'>
      <span>{email}</span>
      {!emailVerified && (
        <button
          onClick={() => {
            setEmailVerifyUserId(userId);
          }}
        >
          <Icon type='alert-circle' size='18' fill='red' stroke='white' />
        </button>
      )}
    </div>
  );
};
